var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "sweet-modal",
        {
          ref: "modal",
          attrs: {
            width: _vm.$mq.desktop ? "500" : "100%",
            "overlay-theme": "dark"
          },
          on: { close: _vm.checkCloseLoginModal }
        },
        [
          _vm.formType === "login"
            ? _c("login-form", {
                ref: "loginForm",
                on: {
                  closeModal: _vm.closeModal,
                  openAppModal: _vm.openAppModal
                }
              })
            : _vm.formType === "register"
            ? _c("register-form", { attrs: { registerFrom: "loginModal" } })
            : _vm.formType === "reset-password"
            ? _c("reset-password-form")
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("login-alert", { ref: "loginAlert" }),
      _vm._v(" "),
      _c("sweet-modal", { ref: "confirmToLogin" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-12" }, [
            _vm._v("\n        " + _vm._s(_vm.confirmMessage) + "\n      ")
          ])
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _vm.platform === "facebook"
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "button-large button-block button-login -indigo",
                    on: {
                      click: function($event) {
                        return _vm.$refs.loginForm.preLogin("facebook")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fab fa-facebook-f" }),
                    _vm._v("   "),
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("message.login.login_with_facebook"))
                      )
                    ])
                  ]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.platform === "googleplus"
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "button",
                  {
                    staticClass: "button-large button-block button-login -red",
                    on: {
                      click: function($event) {
                        return _vm.$refs.loginForm.preLogin("googleplus")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fab fa-google" }),
                    _vm._v("   "),
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.login.login_with_google")))
                    ])
                  ]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.platform === "apple"
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "button-large button-block button-login btn-dark",
                    on: {
                      click: function($event) {
                        return _vm.$refs.loginForm.preLogin("apple")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fab fa-apple fa-lg" }),
                    _vm._v("   "),
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.login.login_with_apple")))
                    ])
                  ]
                )
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30a2b34c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30a2b34c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/LoginModal.vue
// module id = 1395
// module chunks = 0